<template>
  <v-card :loading="isFindGeofencesPending || geofencesSaving">
    <v-card-title>
      <span class="headline">Geofencing</span>
    </v-card-title>
    <v-card-subtitle>
      <span class="subtitle-1">Restirct access to your groups to specific areas using a geofence.</span>
    </v-card-subtitle>
    <v-card-text>
      <p>Groups can then be linked to one or more of the geofence polygon areas to restrict who can join those groups.</p>
      <!-- <Upload
        icon="mdi-map-marker-check"
        icon-color
        label="Geofence File"
        title="Geofence"
        :id="geofenceFileId"
        :multiple="false"
        :data="{ for: 'registrationGeofence' }"
        :actions="['remove', 'download', 'replace']"
        fileTypes=".kml"
        :uploaded="geofenceFileUploaded"
        :removed="deletedGeofenceFile"
      ></Upload> -->
      <Upload
        icon-color
        label="Add Geofences"
        :multiple="false"
        :data="{ for: 'geofence' }"
        :actions="['clear']"
        fileTypes=".kml"
        :uploaded="geofenceFileUploaded"
      ></Upload>
      <v-list class="mt-4" subheader v-if="geofences && geofences.length">
        <v-subheader class="title">Geofences</v-subheader>
        <v-list-item v-for="geofence in orderedGeofences" :key="geofence.id">
          <v-list-item-content>
            <v-list-item-title>
              <v-icon
                :style="{ color: geofence.options && geofence.options.color }"
              >mdi-vector-polygon</v-icon>
              {{geofence.name || geofence.feature.properties.name}}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="grey--text">({{ geofence.member_count }} members)</v-list-item-action>
          <v-list-item-action>
            <v-btn color="accent" icon @click="editGeofence(geofence)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn color="red darken-1" icon @click="deleteGeofence(geofence)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <GeofenceModal :edit.sync="geofenceModal" :geofence="selectedGeofence"></GeofenceModal>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { makeGetMixin, models } from "feathers-vuex";
import Upload from "../widget/Upload";
import GeofenceModal from "./GeofenceModal";

export default {
  data: () => ({
    geofences: [],
    selectedGeofence: {},
    isFindGeofencesPending: false,
    geofenceModal: false,
    geofencesSaving: false,
    registrationGeofenceConfigId: "registrationGeofence",
  }),
  mixins: [
    //makeFindMixin({ service: "geofences" }),
    makeGetMixin({
      service: "configuration",
      name: "registrationGeofence",
      id: "registrationGeofenceConfigId",
    }),
  ],
  async mounted() {
    this.findGeofences();
  },
  computed: {
    ...mapGetters("config", ["registerHasGeofence"]),
    geofencesParams() {
      return {
        query: {},
      };
    },
    orderedGeofences() {
      return this.$orderBy(this.geofences, "name");
    },
    geofenceFileId() {
      return (
        this.registrationGeofence && this.registrationGeofence.config_file_id
      );
    },
  },
  methods: {
    ...mapActions("geofences", { findGeofencesAction: "find" }),
    ...mapActions("config", ["registerHasGeofenceSet"]),
    async findGeofences() {
      this.isFindGeofencesPending = true;
      let geofences = await this.findGeofencesAction({ query: {} });
      this.geofences = geofences.data || [];
      this.isFindGeofencesPending = false;
    },
    async saveGeofence() {
      this.geofencesSaving = true;
      await this.registrationGeofence.save();
      await this.findGeofences();
      this.geofencesSaving = false;
    },
    async editGeofence(geofence) {
      this.selectedGeofence = geofence;
      this.geofenceModal = true;
    },
    async deletedGeofenceFile() {
      await this.findGeofences();
    },
    async deleteGeofence(geofence) {
      await geofence.remove();
      await this.findGeofences();
    },
    async geofenceFileUploaded(file) {
      const { Geofence } = models.bot;
      let geofence = new Geofence();

      geofence.file_id = file[0].id;

      this.geofencesSaving = true;
      await geofence.save();
      await this.findGeofences();
      this.geofencesSaving = false;

      /* this.registrationGeofence.config_file_id = file[0].id;
      await this.saveGeofence(); */
    },
  },
  watch: {
    /*isFindGeofencesPending(pending) {
      console.log('isFindGeofencesPending', pending)
      if (!pending) console.log(this.geofences)
    },*/
    geofenceFileId(id) {
      this.registerHasGeofenceSet(!!id);
    },
  },
  props: {},
  components: {
    Upload,
    GeofenceModal,
  },
};
</script>

<style lang="scss" scoped>
.dot {
  height: 25px;
  width: 25px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
</style>